//按需引入ui组件
import Vue from 'vue';
import {
  Field,
  Button,
  Cell,
  CellGroup,
  Notify,
  Icon,
  Tabbar,
  TabbarItem,
  Loading,
  Checkbox,
  CheckboxGroup,
  Dialog,
  AddressEdit,
  Tab,
  Tabs,
  List,
  PullRefresh,
  Swipe,
  SwipeItem,
  Lazyload,
  Rate,
  Uploader,
  Pagination,
  ImagePreview,
  ActionSheet,
  Step,
  Steps,
  NumberKeyboard,
  PasswordInput
} from 'vant';
Vue.use(Field);
Vue.use(Button);
Vue.use(Notify);
Vue.use(Icon);
Vue.use(Loading);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Dialog);
Vue.use(AddressEdit);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Lazyload);
Vue.use(Rate);
Vue.use(Uploader);
Vue.use(Pagination);
Vue.use(ImagePreview);
Vue.use(ActionSheet );
Vue.use(NumberKeyboard);
Vue.use(PasswordInput);
Vue.use(Cell).use(CellGroup);
Vue.use(Tabbar).use(TabbarItem);
Vue.use(Tab).use(Tabs);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Step).use(Steps);
